module.exports = __webpack_public_path__ + "media/images/Ot4X5q2P-710031ac26392b460c43908a467b1fbd.jpeg";